// extracted by mini-css-extract-plugin
export default {"generalError":"Login_generalError__nFvcb","forgotPassword":"Login_forgotPassword__EsYpZ","recoveryLoginBtn":"Login_recoveryLoginBtn__WXFdH"};